"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const isRedditPixelEnabled = () => {
  return window.__instantTranscriberMarketingConsent !== false;
};

const getCurrentPath = (pathname, searchParams) => {
  const query = searchParams?.toString();
  return query ? `${pathname}?${query}` : pathname;
};

function RedditPixelPageVisitTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname || !isRedditPixelEnabled() || typeof window.rdt !== "function") return;

    const path = getCurrentPath(pathname, searchParams);
    if (window.__instantTranscriberRedditPixelLastPageVisitPath === path) return;

    window.__instantTranscriberRedditPixelLastPageVisitPath = path;
    window.rdt("track", "PageVisit");
  }, [pathname, searchParams]);

  return null;
}

export default function RedditPixelEvents() {
  return (
    <Suspense fallback={null}>
      <RedditPixelPageVisitTracker />
    </Suspense>
  );
}
